/* eslint-disable react/forbid-elements */
import React from 'react';

import {getCloudinaryURL, isCloudinaryEnabled} from 'libs/cloudinary/cloudinary';

export type PropsType = {
    src: string | {default: string};
    fallbackSrc?: string;
    tag?: string;
    alt?: string;
    width?: number | string;
    height?: number | string;
    [key: string]: any;
};

/**
 * Cloudinary Image Component
 * @param {PropsType} props - component properties
 * @param {{current: HTMLImageElement}} ref - component ref
 * @returns {React.ReactNode} rendered component
 */
const Image = React.forwardRef<HTMLImageElement, PropsType>(
    (
        // eslint-disable-next-line react/prop-types
        {src, fallbackSrc = '', alt = '', tag, ...restProps},
        ref: React.Ref<HTMLImageElement>,
    ) => {
        let srcUrl = src || ''; // for integration tests they send here undefined sometimes
        srcUrl = typeof srcUrl === 'string' ? srcUrl : srcUrl.default; // todo Mary a hack for require('.svg')
        const isSvg = srcUrl.endsWith('.svg');
        const url = srcUrl.startsWith('data:image/')
            ? srcUrl
            : getCloudinaryURL(
                  (!isCloudinaryEnabled() && fallbackSrc ? fallbackSrc : srcUrl) || '',
                  tag,
                  isSvg,
              );

        return <img ref={ref} alt={alt} src={url} {...restProps} />;
    },
);

export const CloudinaryImage = React.memo<PropsType>(Image);
